/* HLD — What's Inside, bundle mode: pack tabs (hld-bundle-deck snippet). */
(() => {
  /* <hld-deck-tabs> — WAI-ARIA tabs over the per-pack decks. */
  class HLDDeckTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      const section = this.closest('.hld-deck');
      this.readout = section.querySelector('.hld-deck__readout');
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i, true));
        tab.addEventListener('keydown', (e) => {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (e.key === 'Home' || e.key === 'End' || step) {
            e.preventDefault();
            const n = e.key === 'Home' ? 0 : e.key === 'End' ? this.tabs.length - 1
              : (i + step + this.tabs.length) % this.tabs.length;
            this.select(n, true); this.tabs[n].focus();
          }
        });
      });
    }
    select(i, animate) {
      this.tabs.forEach((tab, j) => {
        const on = i === j;
        tab.setAttribute('aria-selected', String(on));
        tab.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(tab.getAttribute('aria-controls'));
        panel.hidden = !on;
        if (on) {
          const deck = panel.querySelector('hld-flip-deck');
          if (animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
            panel.classList.remove('is-dealing'); void panel.offsetWidth; panel.classList.add('is-dealing');
          }
          if (deck) { deck.scrollLeft = 0; deck.sync && deck.sync(); deck.refresh && deck.refresh(); }
        }
      });
      // Keep the chosen chip in view on the swipeable mobile row.
      const t = this.tabs[i], row = t.parentElement;
      if (row.scrollWidth > row.clientWidth) row.scrollLeft = t.offsetLeft - (row.clientWidth - t.offsetWidth) / 2;
    }
  }
  if (!customElements.get('hld-deck-tabs')) customElements.define('hld-deck-tabs', HLDDeckTabs);
})();
